// @ts-nocheck
import { Dexie } from 'dexie'

const dbVersion = 5
const dbName = 'default'

Dexie.waitFor(
    new Promise((done) => {
        let idb = window.indexedDB.open(dbName)
        idb.onsuccess = async () => {
            let { result: tdb } = idb
            if (tdb.version !== dbVersion * 10) {
                let requestDelete = window.indexedDB.deleteDatabase(dbName)
                requestDelete.onsuccess = () => {
                    tdb.close()
                    done()
                }
            }
            tdb.close()
            done()
        }
    })
)

export const db = new Dexie(dbName,{ chromeTransactionDurability: 'strict' })

db.version(dbVersion).stores({
    invoices:
        'id, ref, cuit, *orden_de_compra, fecha_modificacion, fecha_creacion, fecha_factura, fecha_vencimiento',
    invoices_sin:
        'id, id_proveedor, no_siniestro, patente, punto_venta, no_factura, fecha_factura, tipo_factura, letra, cuit_proveedor, cuit_caja, cae, vencimiento_cae, percepcion, percepcion_provincia, iva, subtotal, total, creation_date, modified_date',
    tranfers:
        'id, banco, cbu, concepto, cuit, denominacion, importe, motivo, nro_red, nro_tranferencia, tipo_tranferencia, fecha_modificacion, fecha_creacion, fecha, fecha_comprobante',
    withholdings:
        'id, cuit, nro_pago, fecha_modificacion, fecha_creacion, fecha, fecha_pago',
    licitaciones:
        '[id+cuit+sucursal.id], id_proveedor_adjudicado, state, fecha_vencimiento, fecha_licitacion, id_siniestro, patente_vehiculo, nombre_apellido_asegurado, dni_asegurado, jurisdiccion, calle, localidad, altura, cp, ubicacion, preseleccionados, ofertas, alcance, demora, motivo_readjudicacion, observacion_readjudicacion, items, reclamo_activo',
    ofertas:
        'id, id_oferta, id_proveedor, state, cuit, id_sucursal, monto_total, tiempo_entrega, items, motivo_rechazo, observacion',
})

export default db
